// extracted by mini-css-extract-plugin
export default {"container":"UserPopularList_container__w1WUa","popular__title":"UserPopularList_popular__title__G36eW"};